import moment from 'moment';

export function Notification(data) {
  var self = this;
  self.id = null;
  self.type = null;
  self.objectId = null;
  self.userId = null;
  self.createDate = new Date();
  self.expireDate = null;

  self.items = [];
  self.__defineGetter__('cnt', function() {
    return self.items.length;
  });

  var recalcStatus = function() {
    var unread = false;
    for (var i = 0; i < self.items.length; i++) {
      if (self.items[i].unread) unread = true;
    }

    self.unread = unread;
  };

  self.__defineGetter__('date', function() {
    return self.items.reduce(function(max, el) {
      return el.createDate > max ? el.createDate : max;
    }, new Date(1900, 0, 0));
  });

  var _unread = true;
  self.__defineGetter__('unread', function() {
    return _unread;
  });
  self.__defineSetter__('unread', function(value) {
    if (!value) for (var i = 0; i < self.items.length; i++) self.items[i].unread = false;
    _unread = value;
  });

  self.getNew = function() {
    return self.items.filter(function(item) {
      return item.unread;
    });
  };
  self.add = function(data) {
    if (!data) return;
    if (data.unread) {
      self.unread = true;
    }

    if (data.json) {
      var temp = JSON.parse(data.json);
      data = {
        ...data,
        ...temp,
      };
    }

    if (typeof data.createDate === 'string') data.createDate = moment.utc(data.createDate).toDate();
    if (typeof data.expireDate === 'string') data.expireDate = moment.utc(data.expireDate).toDate();
    self.items.push(data);
  };
  self.update = function(data) {
    for (var i = 0; i < self.items.length; i++)
      if (self.items[i].id === data.id) {
        if (typeof data.createDate === 'string')
          data.createDate = moment.utc(data.createDate).toDate();
        if (typeof data.expireDate === 'string')
          data.expireDate = moment.utc(data.expireDate).toDate();
        angular.extend(self.items[i], data);

        if (data.expireDate && data.expireDate < new Date()) {
          self.items.splice(i, 1);
          recalcStatus();
          break;
        }

        if (data.unread !== self.unread) recalcStatus();

        break;
      }
  };
  self.remove = function(data) {
    for (var i = 0; i < self.items.length; i++) {
      if (self.items[i].id === data.id) {
        self.items.splice(i, 1);
        recalcStatus();
        break;
      }
    }
  };

  var _param = null;
  self.__defineGetter__('param', function() {
    return _param;
  });
  self.__defineSetter__('param', function(value) {
    _param = value;
  });

  if (data) {
    if (typeof data.createDate === 'string') data.createDate = moment.utc(data.createDate).toDate();
    if (typeof data.expireDate === 'string') data.expireDate = moment.utc(data.expireDate).toDate();
    if (data.json) {
      var jsonData = JSON.parse(data.json);
      Object.assign(data, jsonData);
    }
    angular.extend(self, data);
    self.items.push(data);
  }
}
